<template>
  <data-manager-layout>
    <el-button
      v-if="!readonly"
      slot="actions"
      type="primary"
      icon="el-icon-circle-plus"
      @click="addRow"
    >
      {{ $t('DataManager_Button_CreateMetric') }}
    </el-button>

    <rest-list-editable
      :payload="fetchEndpoint"
      :add-endpoint="rowAddEndpoint"
      :update-endpoint="rowEditEndpoint"
      :rules="rules"
      ref="rest-list"
    >
      <rest-list-column
        prop="title"
        :title="$t('DataManager_Metrics_Field_Title')"
        :editable="true"
      >
        <template slot="input-edit" slot-scope="{ model }">
          <el-input
            v-model="model.title"
            :placeholder="$t('DataManager_Metrics_Field_Title')"
            :disabled="!!model.id"
          />
        </template>
      </rest-list-column>

      <rest-list-column
        prop="name"
        :title="$t('DataManager_Metrics_Field_Name')"
        :editable="true"
      >
        <template slot="input-edit" slot-scope="{ model }">
          <el-input
            v-model="model.name"
            :placeholder="$t('DataManager_Metrics_Field_Name')"
          />
        </template>
      </rest-list-column>

      <rest-list-column
        prop="unit"
        :title="$t('DataManager_Metrics_Field_Unit')"
        :editable="true"
      >
        <template slot="input-edit" slot-scope="{ model }">
          <el-input
            v-model="model.unit"
            :placeholder="$t('DataManager_Metrics_Field_Unit')"
          />
        </template>
      </rest-list-column>

      <rest-list-column-actions v-if="!readonly" :editable="true">
        <template slot-scope="scope">
          <rest-list-action-delete
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="scope.row.title"
          />
        </template>
      </rest-list-column-actions>
    </rest-list-editable>
  </data-manager-layout>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import DataManagerLayout from '@/modules/data-manager/pages/DataManagerLayout'
import { projectEndpoint } from '@/core/helpers'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestListEditable from '@/common/components/rest/RestListEditable'

export default {
  name: 'DataManagerMetricsPage',

  components: {
    RestListEditable,
    RestListActionDelete,
    RestListColumnActions,
    DataManagerLayout,
    RestListColumn
  },

  computed: {
    rules() {
      return {
        title: { required: true },
        name: { required: true },
        unit: { required: true }
      }
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `metrics`,
        params: {
          sort: 'title'
        }
      })
    },

    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `metrics`
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    addRow() {
      const model = {}
      this.$refs['rest-list'].addRow(model)
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `metrics/${row.id}`
      })
    },

    rowEditEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `metrics/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/data-manager/pages/DataManagerMetricsPage.vue